import React from "react";
import { Lightbulb, TrendingUp, Handshake, Heart } from "lucide-react";

const WhyDoubleTap = () => {
  const reasons = [
    {
      icon: Lightbulb,
      title: "Innovation-driven approach",
      description: "We don't just follow trends, we create them"
    },
    {
      icon: TrendingUp,
      title: "Scalable & future-ready solutions",
      description: "Built to grow with your business needs"
    },
    {
      icon: Handshake,
      title: "Transparent collaboration",
      description: "Open communication at every step"
    },
    {
      icon: Heart,
      title: "Passionate team of tech enthusiasts",
      description: "Dedicated professionals who love what they do"
    }
  ];

  return (
    <section id="why-doubletap" className="why-doubletap">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Why DoubleTap?</h2>
        </div>
        
        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div key={index} className="reason-card">
              <div className="reason-icon">
                <reason.icon />
              </div>
              <h3 className="reason-title">{reason.title}</h3>
              <p className="reason-description">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyDoubleTap;